/*
 * @Author: 李家宝 2523472604@qq.com
 * @Date: 2025-06-27 10:35:29
 * @LastEditors: 李家宝 2523472604@qq.com
 * @LastEditTime: 2025-07-03 17:01:17
 * @FilePath: \ngs_platform_manage_admin\src\api\modules\knowledgebaseai.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '../request.js'

// AI文档历史信息查询
export const querySearchHistory = function(data) {
	return request({
		url: '/aiSearchInfo/querySearchHistory',
		method: 'post',
		data
	})
}

// AI问答内容信息查询
export const querySearchQuAndAn = function(data) {
	return request({
		url: '/aiSearchInfo/querySearchQuAndAn',
		method: 'post',
		data
	})
}

// 获取相关度内容信息
export const getContentInfo = function(data) {
	return request({
		url: '/aiSearchInfo/getContentInfo',
		method: 'post',
		data
	})
}

// 获取附件展示信息
export const getFileData = function(data) {
	return request({
		url: '/aiSearchInfo/getFileData',
		method: 'post',
		data
	})
}

// 重命名
export const renameTitle = function(data) {
	return request({
		url: '/aiSearchInfo/renameTitle',
		method: 'post',
		data
	})
}

// 删除
export const deleteSearchHistory = function(data) {
	return request({
		url: '/aiSearchInfo/deleteSearchHistory',
		method: 'post',
		data
	})
}

// 获取下载文件
export const getFileUrl = function(data) {
	return request({
		url: '/aiSearchInfo/getFileUrl',
		method: 'post',
		data
	})
}

export const getManageInfo = function(data) {
	return request({
		url: '/aiSearchInfo/getManageInfo',
		method: 'post',
		data
	})
}

// 获取@的级联树 -- 朱新宇
export const getLibTreeForAISearch = function(data) {
	return request({
		url: '/docManage/getLibTreeForAISearch',
		method: 'post',
		data
	})
}

// 获取选中的文库下面所有的fileld -- 朱新宇
export const getFileIdsForType = function(data) {
	return request({
		url: '/docManage/getFileIdsForType',
		method: 'post',
		data
	})
}

// AI流式对话接口（fetch实现，自动适配baseURL）
export function streamChat(data) {
	const baseUrl = process.env.VUE_APP_STREAM_API || 'http://172.16.0.146:8080'
	const url = baseUrl + '/api/chat/streamChat'
	return fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			token: sessionStorage.getItem('ngs_platform_token') || ''
		},
		body: JSON.stringify(data)
	})
	// return request({
	// 	baseURL: baseUrl,
	// 	url: '/api/chat/streamChat',
	// 	method: 'post',
	// 	data,
	// 	headers: {
	// 		'Content-Type': 'application/json'
	// 	}
	// })
}
